import React from 'react';

import { colors } from 'global/colors';
import Rating from '../Rating/Rating';
import {
  FilterContainer,
  Title,
  Label,
  ClearButton,
  RatingContainer,
  ClearRatingButton,
  FilterSection,
  KeywordsContainer,
  LabelContainer,
  AmountLabel,
} from './styles';
import { FilterCheckbox } from 'components/Checkbox/Checkbox';

export default function Filter({ options, clearFilters, hasFilters, items, style }) {
  const renderItem = (option) => {
    switch (option.type) {
      case 'keywords':
        return renderKeywords(option);
      case 'rating':
        return renderRating(option);
      default:
        return null;
    }
  };

  const renderKeyword = (item, option) => {
    const amount = option.getAmount ? option.getAmount(item) : items.filter((i) => i.keywords.includes(item)).length;
    return (
      <Label key={item}>
        <FilterCheckbox
          onChange={(e) => {
            e.stopPropagation();
            if (!option.selectedKeywords.find((tag) => tag === item)) {
              option.onChange([...option.selectedKeywords, item]);
            } else {
              option.onChange(option.selectedKeywords.filter((tag) => tag !== item));
            }
          }}
          checked={!!option.selectedKeywords.find((tag) => item === tag)}
          label={item}
        />
        <LabelContainer>
          <AmountLabel>({amount})</AmountLabel>
        </LabelContainer>
      </Label>
    );
  };

  const renderKeywords = (option) => {
    return option.items.length > 0 ? (
      <FilterSection key={option.title}>
        <Title>{option.title}</Title>
        <KeywordsContainer>{option.items.map((item) => renderKeyword(item, option))}</KeywordsContainer>
      </FilterSection>
    ) : null;
  };

  const renderRating = (option) => {
    return (
      <FilterSection key={option.title}>
        <Title>{option.title}</Title>
        <RatingContainer onClick={(e) => e.stopPropagation()}>
          <Rating rating={option.selectedRating} size={12} onChange={option.onChange} color={colors.yellow4} />
          {option.selectedRating && (
            <ClearRatingButton onClick={() => option.onChange(undefined)}>Clear</ClearRatingButton>
          )}
        </RatingContainer>
      </FilterSection>
    );
  };

  return (
    <FilterContainer style={style}>
      {hasFilters && (
        <ClearButton onClick={clearFilters}>{options.length > 1 ? 'Clear all filters' : 'Clear filter'}</ClearButton>
      )}
      {options.map(renderItem)}
    </FilterContainer>
  );
}
